module.exports = __webpack_public_path__ + "img/8.1b78e094.jpg";